<script>
import SearchSuggestionsList from './components/SearchSuggestionsList.vue';
import SearchSuggestionsPosts from './components/SearchSuggestionsPosts.vue';
import SearchSuggestionsProducts from './components/SearchSuggestionsProducts.vue';
import BaseDesktopBlockContainer from './components/BaseDesktopBlockContainer.vue';
import { fetchPosts, fetchSuggestions } from './api';
import { getTranslate } from '../../utils/translations';
import { serializeProducts, serializeSuggestions } from './utils/api-util';
import { asyncDebounce } from '../../utils/debounce';

const translate = getTranslate(window.searchSuggestionsTranslations);

export default {
    name: 'SearchSuggestionsApp',
    components: {
        BaseDesktopBlockContainer,
        SearchSuggestionsList,
        SearchSuggestionsPosts,
        SearchSuggestionsProducts
    },
    provide: {
        $t: (key) => translate(key)
    },
    inject: ['options'],
    data() {
        return {
            isOpen: false,
            minSearchLength: 3,
            searchInput: document.querySelector(this.options.inputSelector),
            searchInputValue: '',
            searchData: {
                posts: [],
                products: [],
                suggestions: []
            },
            fetchDataDebounced: async () => []
        };
    },
    computed: {
        isSearchData() {
            const { suggestions, posts, products } = this.searchData;

            return !!(suggestions.length || posts.length || products.length);
        },
        showSuggestions() {
            return (
                this.searchInputValue.length >= this.minSearchLength &&
                this.isSearchData
            );
        }
    },
    watch: {
        async searchInputValue() {
            if (
                !this.searchInputValue ||
                this.searchInputValue.length < this.minSearchLength
            )
                return;

            await this.fetchDataDebounced();
            this.isOpen = true;
        },
        showSuggestions() {
            window.dispatchEvent(
                new CustomEvent('disable-sticky', {
                    detail: this.showSuggestions
                })
            );
        }
    },
    mounted() {
        this.addListeners();
        this.fetchDataDebounced = asyncDebounce(() => this.fetchData(), 500);
    },
    methods: {
        setSearchInputValue() {
            this.searchInputValue = this.searchInput.value;
        },
        addListeners() {
            this.searchInput.addEventListener('input', () =>
                this.setSearchInputValue()
            );

            window.addEventListener('close-suggestions', () => {
                this.isOpen = false;
            });
        },
        async fetchData() {
            const payload = await fetchSuggestions(this.searchInputValue);
            const products = serializeProducts(payload);
            const suggestions = serializeSuggestions(payload);
            const posts = await fetchPosts(this.searchInputValue);

            this.searchData.products = products;
            this.searchData.suggestions = suggestions;
            this.searchData.posts = posts;
        }
    }
};
</script>

<template>
    <div v-show="showSuggestions && isOpen" class="suggestions"
>
        <BaseDesktopBlockContainer
            :only-desktop="true"
            class="suggestion-container top-5 left-0 pt-0 lg:absolute lg:h-auto lg:rounded-t-none lg:pt-8"
        >
            <div class="mt-3 flex flex-col">
                <SearchSuggestionsList
                    :search-string="searchInputValue"
                    :suggestions="searchData.suggestions"
                    class="border-base-line mb-6 border-b pb-6"
                />
                <SearchSuggestionsPosts
                    :posts="searchData.posts"
                    class="mb-6"
                />
                <SearchSuggestionsProducts :products="searchData.products" />
            </div>
        </BaseDesktopBlockContainer>
    </div>
</template>

<style lang="postcss" scoped>
.suggestion-container {
    max-height: calc(100vh - 13.5rem);
    z-index: -1;
    @apply lg:max-h-unset overflow-y-auto lg:overflow-visible;
}

.sw-header-sticky {
    .suggestion-container {
        @apply overflow-y-auto;

        @screen lg {
            height: auto;
            max-height: calc(100vh - 5.5rem);
        }
    }
}
</style>
